import { createSelector } from '@ngrx/store';
import { getNewRepeatOrderState } from '../../../reducers';
import {
  getShippingConditions,
  getJobsitesAvailable,
  getPointOfDeliveries,
  getBusinessLine,
  getJobsiteState,
  getPurchaseOrderState,
} from '@ordersnproducts/modules/order-builder/reducers';
import { getReceivingPersonEntities } from '@ordersnproducts/modules/shared/modules/receiving-person/redux/selectors/index';
import { getOrderSelectedDetail } from '@ordersnproducts/modules/new-repeat-order/selectors/order-selected-detail.selector';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * Exports rms specification state
 */
export const getTopLocation = createSelector(getNewRepeatOrderState, state => {
  return state.topLocation;
});

export const getTopLocationForm = createSelector(getTopLocation, state => {
  return state.topLocationFormState.forms;
});

/**
 * Custom Selectors
 */
export const dataShippingConditions = createSelector(
  getShippingConditions,
  getOrderSelectedDetail,
  (shippingConditions, order) => {
    return {
      shippingConditions,
      order,
    };
  },
);

export const dataJobsites = createSelector(getJobsitesAvailable, getOrderSelectedDetail, (jobsites, order) => {
  return {
    jobsites,
    order,
  };
});

export const dataPointOfDeliveryAndContact = createSelector(
  getPointOfDeliveries,
  getOrderSelectedDetail,
  getReceivingPersonEntities,
  (pointOfDelivery, order, contact) => {
    return {
      pointOfDelivery,
      order,
      contact,
    };
  },
);

export const dataShippingConditionsAndCustomer = createSelector(
  getShippingConditions,
  getLegalEntity,
  (shippingConditions, customer) => {
    return {
      shippingConditions,
      customer,
    };
  },
);

/**
 * Exports purchase order validation state
 */

export const getTopLocationPurchaseOrder = createSelector(getTopLocation, state => {
  return state.topLocationFormState.purchaseOrder;
});

export const getPurchaseOrderValidationLocationData = createSelector(
  getBusinessLine,
  getJobsiteState,
  getPurchaseOrderState,
  (businessLineState, jobsiteState, purchaseOrderLocationState) => {
    return {
      productLine: _safe(() => businessLineState.selected.productTypeCode),
      jobsiteId: _safe(() => jobsiteState.selected.shipmentLocationId),
      isValidationRequired: purchaseOrderLocationState.required,
    };
  },
);

export const getPurchaseOrderValidationData = createSelector(
  getBusinessLine,
  getJobsiteState,
  getTopLocationPurchaseOrder,
  (businessLineState, jobsiteState, purchaseOrderState) => {
    return {
      productLine: _safe(() => businessLineState.selected.productTypeCode),
      jobsiteId: _safe(() => jobsiteState.selected.shipmentLocationId),
      isValidationRequired: purchaseOrderState.required,
    };
  },
);

export const getValidPOMaskExpressions = createSelector(getTopLocationPurchaseOrder, state => {
  return state.validMasks;
});
